import styled, { css } from 'styled-components';

import { Grid } from '@/components/Grid';
import { theme } from '@/theme';

/**
 * ProductsGrid - Responsive grid layout for product listings
 *
 * This component handles different layouts based on:
 * 1. Screen size (responsive breakpoints)
 * 2. Product type (watches/straps vs eyewear)
 *
 * The grid shows 5 columns for watches and straps,
 * but 4 columns for eyewear products on medium and larger screens.
 */
export const ProductsGrid = styled(Grid)<{ $productType?: string }>`
  /* Mobile layout (all product types) */
  grid-template-columns: repeat(2, 1fr);
  margin-bottom: ${({ theme }) => theme.spacing(3)};
  overflow: hidden;

  /* Small screens (all product types) */
  ${theme.media.sm.up} {
    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  }

  /* Default grid layout for watches and straps - 5 columns */
  ${theme.media.md.up} {
    display: grid !important;
    grid-template-columns: repeat(5, 1fr) !important;
  }

  /* Override for eyewear products ONLY - 4 columns */
  ${({ $productType }) =>
    $productType === 'eyewear' &&
    css`
      ${theme.media.md.up} {
        display: grid !important;
        grid-template-columns: repeat(4, 1fr) !important;
      }
    `}

  /* Force 5-column layout for watch and default types */
  ${({ $productType }) =>
    ($productType === 'watch' || !$productType) &&
    css`
      ${theme.media.md.up} {
        display: grid !important;
        grid-template-columns: repeat(5, 1fr) !important;
      }
    `}
`;
